// 配置 pattern
export default [{
	//模式首页
	path: '/pattern',
	name: 'pattern',
	component: () => import('@/views/pattern/pattern.vue')
}, {
	//模式介绍
	path: '/introduce',
	name: 'introduce',
	component: () => import('@/views/pattern/introduce.vue')
}, {
	//机构介绍
	path: '/mechanism',
	name: 'mechanism',
	component: () => import('@/views/pattern/mechanism.vue')
}, {
	//园所介绍
	path: '/garden',
	name: 'garden',
	component: () => import('@/views/pattern/garden.vue'),
}, {
	//园所详情
	path: '/garden/details',
	name: 'gardenDetails',
	component: () => import('@/views/pattern/gardenDetails.vue')
}]



// WEBPACK FOOTER //
// ./src/router/modules/pattern.js